import React from 'react'

type Props = {
    data: {
        label?: string
        value?: any
    }
}

export default class InfoParam extends React.PureComponent<Props> {

    render() {
        return (
            <div className="param">
                {!!this.props.data.label &&
                <div className="label">
                    {this.props.data.label}:
                </div>}
                {!!this.props.data.value &&
                <div className="value">
                    {this.props.data.value}
                </div>}
            </div>
        )
    }
}
